export default __webpack_public_path__ + "static/media/1952.6081c28e.png";